<template>
  <div>
    <v-row no-gutters>
      <v-col cols="6" sm="5">{{ $t('location') }}:</v-col>
      <v-col>
        <span class="text--secondary">{{ locationText || $t('notSpecified') }}</span>
        <Icon
        v-if="hasCoordinates"
        icon="mdi-map"
        iconColor="info"
        tabindex="0"
        class="ml-1"
        elementId="bid-location-view-on-map"
        :tooltipText="$t('viewOnMap')"
        @icon-clicked="showMap = true"/>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="6" sm="5">{{ $t('latitude') }}:</v-col>
      <v-col><span class="text--secondary">{{ spot.latitude }}</span></v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="6" sm="5">{{ $t('longitude') }}:</v-col>
      <v-col><span class="text--secondary">{{ spot.longitude }}</span></v-col>
    </v-row>
    <v-dialog v-model="showMap" max-width="900px">
      <BidLocationMapDialog
      v-if="showMap"
      readonly
      :propLocation="mapLocation"
      @close="showMap = false"/>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'BidLocationDisplay',

  components: {
    Icon: () => import('@/components/helper/Icon.vue'),
    BidLocationMapDialog: () => import('@/components/bid/BidLocationMapDialog.vue')
  },

  props: {
    spot: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    showMap: false
  }),

  computed: {
    locationText () {
      const { countrySubdivision: state, countrySecondarySubdivision: county } = this.spot
      return state && county ? `${county}, ${state}` : undefined
    },

    hasCoordinates () {
      return typeof this.spot.latitude === 'number' && typeof this.spot.longitude === 'number'
    },

    mapLocation () {
      return { latitude: this.spot.latitude, longitude: this.spot.longitude }
    }
  }
}
</script>
